import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { RequestData } from 'src/app/common/models/request-data.model';

@Injectable({
  providedIn: 'root'
})
export class SaleItemBulkUpdateService {

  constructor(private http: HttpClient) { }

  /**
   * Fetch list of staged bulk updates with filters/pagination
   */
  getList(requestData: RequestData): Observable<any> {
    return this.http.post<any>(environment.baseUrl + '/sale-item-bulk-update/get', requestData);
  }

  /**
   * Fetch current update schedule date and type
   */
  getScheduleDetails(): Observable<any> {
    return this.http.get<any>(environment.baseUrl + '/sale-item-bulk-update/schedule-details');
  }

  /**
   * Update scheduled publish date for all draft changes
   */
  updateScheduleDate(publishAt: string): Observable<any> {
    return this.http.post<any>(environment.baseUrl + '/sale-item-bulk-update/update-schedule', { date_on: publishAt });
  }

  /**
   * Exclude a single item from the current bulk updates staging
   */
  excludeItem(itemId: number): Observable<any> {
    return this.http.post<any>(environment.baseUrl + '/sale-item-bulk-update/exclude/' + itemId, {});
  }

  /**
   * Discard all bulk update draft records in staging
   */
  discard(): Observable<any> {
    return this.http.post<any>(environment.baseUrl + '/sale-item-bulk-update/discard', {});
  }

  /**
   * Publish staged revisions to live items catalog
   */
  publish(): Observable<any> {
    return this.http.post<any>(environment.baseUrl + '/sale-item-bulk-update/publish', {});
  }

  /**
   * Export sale item bulk update template sheet
   * @param exportType 1 = Item Name Change, 2 = Item Price Change, 3 = Item Delete
   */
  exportTemplate(exportType: number): Observable<Blob> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.http.post(
      environment.baseUrl + '/sale-item-bulk-update/export', 
      { selected_export_type: exportType }, 
      { headers, responseType: 'blob' }
    );
  }

  /**
   * Import bulk update file
   * @param file The excel sheet file
   * @param publishDate The schedule publish date
   */
  importTemplate(file: File, publishDate: string): Observable<any> {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('updated_price_date', publishDate);
    formData.append('import_module', 'sale_item_bulk_updates');
    
    return this.http.post<any>(environment.baseUrl + '/sale-item-bulk-update/import', formData);
  }
}
